import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Use sessionStorage instead of localStorage so the admin token is cleared
// when the tab closes, reducing XSS-token-theft blast radius.
const TOKEN_KEY = "tmp_admin_token";
export const adminToken = () => {
  try {
    return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY) || null;
  } catch {
    return null;
  }
};
export const setAdminToken = (t) => {
  try { sessionStorage.setItem(TOKEN_KEY, t); } catch (e) { void e; }
};
export const clearAdminToken = () => {
  try { sessionStorage.removeItem(TOKEN_KEY); localStorage.removeItem(TOKEN_KEY); } catch (e) { void e; }
};
export const adminAuthHeaders = () => {
  const t = adminToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};
